import React from 'react';
import styled, { keyframes } from 'styled-components';

let spin = keyframes('spin', {
  from: { transform: 'rotate(0deg)' },
  to: { transform: 'rotate(360deg)' },
});

const pxSize = {
  small: 14,
  medium: 28,
  large: 60,
};

const Spinner = styled.div`
  animation: ${spin} 0.5s infinite linear;
  border-right: solid 3px ${p => p.color};
  border-bottom: solid 3px ${p => p.color};
  border-left: solid 3px transparent;
  border-top: solid 3px transparent;
  border-radius: ${p => pxSize[p.size]}px;
  width: ${p => pxSize[p.size]}px;
  height: ${p => pxSize[p.size]}px;
  left: 50%;
  top: 50%;
  margin-top: -${p => pxSize[p.size] / 2}px;
  margin-left: -${p => pxSize[p.size] / 2}px;
  position: absolute;
  z-index: 1;

  ${p => (p.inline ? 'position:static;margin:0;' : '')}

  &:hover: {
    border-right: solid 3px #666;
    border-bottom: solid 3px #666;
  }
`;

const Loading = ({ color = '#ccc', size = 'large', inline = false }) => {
  return <Spinner size={size} color={color} inline={inline} />;
};

export default Loading;
